import { Button as ButtonPrimitive } from "@base-ui/react/button"
import { cva, type VariantProps } from "class-variance-authority"
import type { ComponentProps } from "react"

import { cn } from "@/lib/utils"

export const buttonVariants = cva("button", {
  variants: {
    variant: {
      solid: "button--solid",
      outline: "button--outline",
      ghost: "button--ghost",
    },
    size: {
      default: "button--default",
      icon: "button--icon",
      sm: "button--sm",
    },
  },
  defaultVariants: {
    variant: "solid",
    size: "default",
  },
})

type ButtonProps = ComponentProps<typeof ButtonPrimitive> &
  VariantProps<typeof buttonVariants>

export function Button({ className, variant, size, ...props }: ButtonProps) {
  return (
    <ButtonPrimitive
      className={cn(buttonVariants({ variant, size }), className)}
      {...props}
    />
  )
}
